import { ApplicationConfig } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideAuthStrategy } from './auth-strategy.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    // Nonce (Default) vs. JWT wird per angular.json fileReplacements
    // entschieden (Build-Zeit, kein Laufzeit-Branching) — siehe ADR 0003.
    ...provideAuthStrategy(),
  ],
};
